import React from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { isMobile } from 'react-device-detect';
import Config from '../../../config';

const ErrorNotification = (props) => {
  const { retry } = props;
  const dispatch = useDispatch();

  const retryFailedRequest = () => {
    if (retry.noDispatch) {
      retry.action(...retry.args);
    } else {
      dispatch(retry.action(...retry.args));
    }
  };

  return (
    <Container>
      <IconWrapper>
        <img src={Config.ImageAssets.notifications.info} alt="icon" />
      </IconWrapper>
      <MessageWrapper>
        <Message>{Config.TextStrings.errorMessage}</Message>
      </MessageWrapper>
      {retry && retry.action && typeof retry.action === 'function' && (
        <RetryButton onClick={retryFailedRequest}>
          {Config.TextStrings.retry}
        </RetryButton>
      )}
      <Close>
        <img src={Config.ImageAssets.notifications.close} alt="close" />
      </Close>
    </Container>
  );
};

const Container = styled.div`
  color: white;
  background-color: ${Config.Color.error};
  height: auto;
  text-align: center;
  padding: ${isMobile ? 0 : '8px'};
  margin: ${isMobile ? '8px 8px 0 8px' : 0};
  width: 100%;
  display: grid;
  grid-template-columns: ${isMobile ? '60px auto 60px' : '80px auto auto 80px'};
  grid-template-rows: ${isMobile ? 'auto auto' : 'auto'};
  justify-items: center;
  border-radius: 5px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.75);
`;

const IconWrapper = styled.div`
  align-self: center;
  margin: 12px;
`;

const Close = styled.div`
  align-self: center;
  margin: 12px;
  grid-column: ${isMobile ? '3' : '4'};
`;

const MessageWrapper = styled.div`
  align-self: center;
  justify-self: left;
`;

const Message = styled.div`
  text-align: left;
  font-size: ${isMobile ? '12px' : '12px'};
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
`;

const RetryButton = styled.button`
  background-color: ${Config.Color.whiteDimmed};
  align-self: center;
  justify-self: ${isMobile ? 'center' : 'end'};
  border: none;
  border-radius: 22px;
  padding: 12px 24px;
  color: ${Config.Color.white};
  text-transform: uppercase;
  font-size: 14px;
  font-weight: bold;
  grid-row-start: ${isMobile ? 2 : 1};
  grid-column-start: ${isMobile ? 2 : 3};
  margin: 12px 0;
  &:hover {
    text-decoration: none;
    color: ${Config.Color.white};
  }
`;

export default ErrorNotification;
